export default "__VITE_ASSET__6403096d__"